import { out } from "@/lib/output/out";
import { readCatalogList } from "@/commands/catalog/read-catalog-list";
import type { ApiOutputs } from "@/lib/api/api-outputs";
import type { ParsedArgs } from "@/lib/parsed/parsed-args";

export async function listCatalogRepos(
  parsed: ParsedArgs,
  asJson: boolean,
): Promise<void> {
  const result = await readCatalogList<ApiOutputs["catalog"]["repos"]>(
    parsed,
    "/repos",
    "repos",
  );
  if (asJson) {
    out.json(result);
    return;
  }
  for (const repo of result.repos) {
    out.line(out.cell(repo));
  }
}
